interface NeoErrorProps {
  message?: string;
}

export const NeoSuccess: React.FC<NeoErrorProps> = ({message}) => {
  return <h6 className="py-3 text-tiny text-success">{message}</h6>;
};
